import HeroBg from "public/ransomwareProtection/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Secure Your Business Now",
    link: "contact-us",
  },
  title: "Defense Against Ransomware, DDoS & Unauthorized Access ",
  desc: "Detect, prevent, and respond—before threats strike.Secure your data with our multi-layered defense strategy.",
  image: HeroBg,
};
